"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var PinItComponent = /** @class */ (function () {
    function PinItComponent() {
        this.url = location.href;
        this.media = '';
        this.description = '';
        // load pinterest sdk if required
        var url = 'https://assets.pinterest.com/js/pinit.js';
        if (!document.querySelector("script[src='" + url + "']")) {
            var script = document.createElement('script');
            script.src = url;
            script['data-pin-build'] = 'parsePins';
            document.body.appendChild(script);
        }
    }
    PinItComponent.prototype.ngAfterViewInit = function () {
        // render pin it button
        window['parsePins'] && window['parsePins']();
    };
    PinItComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'pin-it',
                    template: "<a href=\"//www.pinterest.com/pin/create/button/?url={{url}}&media={{media}}&description={{description}}\" data-pin-do=\"buttonPin\" data-pin-config=\"beside\"></a>"
                },] },
    ];
    /** @nocollapse */
    PinItComponent.ctorParameters = function () { return []; };
    PinItComponent.propDecorators = {
        "url": [{ type: core_1.Input },],
        "media": [{ type: core_1.Input },],
        "description": [{ type: core_1.Input },],
    };
    return PinItComponent;
}());
exports.PinItComponent = PinItComponent;
